<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

    page: {
        title: 'Новый транк',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader, Multiselect },

    data() {
        return {
            title: 'Новый транк',
            items: [],
            trunk_uuid: '',
            name: '',
            limit_calls_from_number: 2000,
            config: '',
            trackBy: 'id',
            initStatus: [],
            status: null,
            status_options: [
                {id: 'created',  name: 'Новый'},
                {id: 'connect',  name: 'Подключение'},
                {id: 'active',   name: 'Активен'},
                {id: 'blocked',  name: 'Заблокирован'},
                {id: 'disabled', name: 'Отключен'}
            ],
            qnt_phones: null,
            operator: null,
            initOperator: [],
            operators_options: [],
            account: null,
            initAccount: [],
            account_options: [],
            context_name: '',
            fl_outer: false,
            qnt_calls_limit: 20,
            fl_division_numbers_off: false,
            default_caller: null,
            initDefaultCaller: [],
            default_callers_options: [],
            default_pbx: null,
            default_outer_caller_number: null,
            initDefaultPBX: [],
            default_pbx_options: [],
        }
    },

    watch: {
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
        initOperator: {
            immediate: true,
            handler(values) {
                this.operator = this.operators_options.filter(x => values.includes(x[this.trackBy]));
                this.operator = this.operator[0];
            }
        },
        initDefaultCaller: {
            immediate: true,
            handler(values) {
                this.default_caller = this.default_callers_options.filter(x => values.includes(x[this.trackBy]));
                this.default_caller = this.default_caller[0];
            }
        },
        initDefaultPBX: {
            immediate: true,
            handler(values) {
                this.default_pbx = this.default_pbx_options.filter(x => values.includes(x[this.trackBy]));
                this.default_pbx = this.default_pbx[0];
            }
        },
        initAccount: {
            immediate: true,
            handler(values) {
                this.account = this.account_options.filter(x => values.includes(x[this.trackBy]));
                this.account = this.account[0];
            }
        },
    },

    computed: {
        trunk_item(){
            return this.$store.getters['trunks/GET_TRUNKS_ITEM'];
        },
        trunks_phones_list_data(){
            return this.$store.getters['trunksPhones/GET_TRUNKS_PHONES_LIST_DATA'];
        },
        operators_list_data(){
            return this.$store.getters['operators/GET_OPERATORS_LIST_DATA'];
        },
        accounts_list_data(){
            return this.$store.getters['accounts/GET_ACCOUNTS_LIST_DATA'];
        },
        servers_list_data(){
            return this.$store.getters['servers/GET_SERVERS_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
    },

    async mounted() {

        this.trunk_uuid = this.$route.params.trunk_uuid ? this.$route.params.trunk_uuid : '';

        await this.$store.dispatch('operators/FETCH_OPERATORS_LIST', {});
        this.operators_options = this.operators_list_data;

        await this.$store.dispatch('accounts/FETCH_ACCOUNTS_LIST', {limit: 2000});
        this.account_options = this.accounts_list_data;

        await this.$store.dispatch('servers/FETCH_SERVERS_LIST', {});
        this.default_pbx_options = this.servers_list_data;

        if(this.trunk_uuid !== ''){

            this.title = 'Настройка транка';
            document.title = appConfig.title + ' - ' + 'Настройка транка';

            let data_send = {
                'uuid' : this.trunk_uuid
            }

            await this.$store.dispatch('trunks/FETCH_TRUNKS_ITEM', data_send);

            let filter = {
                'trunk_id' : this.trunk_item.id,
                'status'   : 'active'
            }

            data_send = {
                'where' : JSON.stringify(filter),
                'limit': 1000
            }

            await this.$store.dispatch('trunksPhones/FETCH_TRUNKS_PHONES_LIST', data_send);
            this.default_callers_options = this.trunks_phones_list_data;

            this.name    = this.trunk_item.name ? this.trunk_item.name : '';
            this.limit_calls_from_number = this.trunk_item.limit_calls_from_number ? this.trunk_item.limit_calls_from_number : 0;
            this.config  = this.trunk_item.config ? JSON.parse(this.trunk_item.config) : this.config;
            this.account = this.trunk_item.account_id ? this.trunk_item.account_id : null;
            this.qnt_phones = this.trunk_item.qnt_phones ? this.trunk_item.qnt_phones : null;
            this.default_outer_caller_number = this.trunk_item.default_outer_caller_number ? this.trunk_item.default_outer_caller_number : null;
            this.status = this.trunk_item.status ? this.trunk_item.status : '';
            this.fl_outer = this.trunk_item.fl_outer ? this.trunk_item.fl_outer : '';
            this.fl_division_numbers_off = this.trunk_item.fl_division_numbers_off ? this.trunk_item.fl_division_numbers_off : '';
            this.context_name = this.trunk_item.context_name ? this.trunk_item.context_name : '';
            this.qnt_calls_limit = this.trunk_item.qnt_calls_limit ? this.trunk_item.qnt_calls_limit : '';

            this.initStatus = [this.status];

            if(this.account) this.initAccount = [this.account];

            this.operator = this.trunk_item.operator_id ? this.trunk_item.operator_id : null;
            if (this.operator !== null) {
                this.initOperator = [this.operator];
            }

            this.default_caller = this.trunk_item.default_caller_id ? this.trunk_item.default_caller_id : null;
            if (this.default_caller !== null) {
                this.initDefaultCaller = [this.default_caller];
            }

            this.default_pbx = this.trunk_item.default_pbx_id ? this.trunk_item.default_pbx_id : null;
            if (this.default_pbx !== null) {
                this.initDefaultPBX = [this.default_pbx];
            }
        }
    },

    methods: {

        async saveItem(){

            let fl_outer = 'false';
            let fl_division_numbers_off = 'false';

            if(this.fl_outer === true){
                fl_outer = 'true';
            }
            if(this.fl_division_numbers_off === true){
                fl_division_numbers_off = 'true';
            }

            let data_send = {
                'name' : this.name,
                'qnt_phones' : this.qnt_phones,
                'account_id' : this.account && this.account.id ? this.account.id : null,
                'user_id' :  this.account && this.account.user_id ? this.account.user_id : null,
                'config'  : JSON.stringify(this.config),
                'fl_outer' : fl_outer,
                'fl_division_numbers_off' : fl_division_numbers_off,
                'context_name' : this.context_name,
                'qnt_calls_limit': this.qnt_calls_limit,
                'default_outer_caller_number': this.default_outer_caller_number,
                'status'  : this.status && this.status.id ? this.status.id : null,
                'operator_id' : this.operator && this.operator.id ? this.operator.id : null,
                'default_caller_id' : this.default_caller && this.default_caller.id ? this.default_caller.id : null,
                'default_caller_number' : this.default_caller && this.default_caller.number ? this.default_caller.number : null,
                'default_pbx_id' : this.default_pbx && this.default_pbx.id ? this.default_pbx.id : null,
                'default_pbx_ip' : this.default_pbx && this.default_pbx.ip ? this.default_pbx.ip : null,
                'limit_calls_from_number': this.limit_calls_from_number
            };

            let result = '';

            if(this.trunk_uuid === ''){
                result = await this.$store.dispatch('trunks/FETCH_TRUNKS_CREATE', data_send);
            } else {
                data_send.uuid = this.trunk_uuid;
                result = await this.$store.dispatch('trunks/FETCH_TRUNKS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Trunks'});
            }
        }
    },
}

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Аккаунт клиента"
                                        label-for="account"
                                    >
                                        <multiselect
                                            id="account"
                                            :track-by="trackBy"
                                            v-model="account"
                                            :options="account_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Название транка"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="Укажите название транка"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Оператор"
                                        label-for="operator"
                                    >
                                        <multiselect
                                            id="operator"
                                            :track-by="trackBy"
                                            v-model="operator"
                                            :options="operators_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Параметры"
                                        label-for="config"
                                    >
                                        <b-form-textarea
                                            id="config"
                                            v-model="config"
                                            rows="4"
                                        ></b-form-textarea>
                                    </b-form-group>

                                    <b-form-group
                                        label="Количество телефонных номеров"
                                        label-for="qnt_phones"
                                    >
                                        <b-form-input
                                            id="qnt_phones"
                                            v-model="qnt_phones"
                                            placeholder="Укажите количество номеров"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Количество звонков с номера для его замены"
                                        label-for="limit_calls_from_number"
                                    >
                                        <b-form-input
                                            id="limit_calls_from_number"
                                            v-model="limit_calls_from_number"
                                            placeholder="Укажите звонков"
                                        ></b-form-input>
                                    </b-form-group>                                    

                                    <b-form-checkbox v-model="fl_division_numbers_off" name="fl_outer" style="margin-top: 15px; margin-bottom: 15px" switch>
                                        Отключить карусель распределения номеров
                                    </b-form-checkbox>

                                    <b-form-group
                                        v-if="fl_division_numbers_off"
                                        label="Номер телефона по умолчанию"
                                        label-for="default_caller"
                                    >
                                        <multiselect
                                            id="default_caller"
                                            :track-by="trackBy"
                                            v-model="default_caller"
                                            :options="default_callers_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-checkbox v-model="fl_outer" name="fl_outer" style="margin-top: 15px; margin-bottom: 15px" switch>
                                        Использовать внешний транк
                                    </b-form-checkbox>

                                    <b-form-group
                                        v-if="fl_outer"
                                        label="Название контекста"
                                        label-for="context_name"
                                    >
                                        <b-form-input
                                            id="context_name"
                                            v-model="context_name"
                                            placeholder="Укажите название контекста"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        v-if="fl_outer"
                                        label="АТС по умолчанию"
                                        label-for="default_pbx"
                                    >
                                        <multiselect
                                            id="default_pbx"
                                            :track-by="trackBy"
                                            v-model="default_pbx"
                                            :options="default_pbx_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Внешний номер телефона"
                                        label-for="default_outer_caller_number"
                                    >
                                        <b-form-input
                                            id="default_outer_caller_number"
                                            v-model="default_outer_caller_number"
                                            placeholder="Укажите номер телефона"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        v-if="fl_outer || fl_division_numbers_off"
                                        label="Лимит звонков в минуту"
                                        label-for="qnt_calls_limit"
                                    >
                                        <b-form-input
                                            id="qnt_calls_limit"
                                            v-model="qnt_calls_limit"
                                            placeholder="Укажите количество звонков в минуту "
                                        ></b-form-input>
                                    </b-form-group>                                    

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            :track-by="trackBy"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
